import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DashboardStats {
  totalOrders: number;
  pendingOrders: number;
  syncedOrders: number;
  monthlyOrdersData: number[];
  monthlyLabels: string[];
}

interface DashboardStatsState {
  stats: DashboardStats;
  isLoading: boolean;
  error: string | null;
}

const initialState: DashboardStatsState = {
  stats: {
    totalOrders: 0,
    pendingOrders: 0,
    syncedOrders: 0,
    monthlyOrdersData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    monthlyLabels: [
      "Out",
      "Nov",
      "Dez",
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
    ],
  },
  isLoading: false,
  error: null,
};

const dashboardStatsSlice = createSlice({
  name: "dashboardStats",
  initialState,
  reducers: {
    setDashboardStats(state, action: PayloadAction<DashboardStats>) {
      state.stats = action.payload;
      state.error = null;
    },
    setTotalOrders(state, action: PayloadAction<number>) {
      state.stats.totalOrders = action.payload;
    },
    setPendingOrders(state, action: PayloadAction<number>) {
      state.stats.pendingOrders = action.payload;
    },
    setSyncedOrders(state, action: PayloadAction<number>) {
      state.stats.syncedOrders = action.payload;
    },
    setMonthlyOrdersData(state, action: PayloadAction<number[]>) {
      state.stats.monthlyOrdersData = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError(state) {
      state.error = null;
    },
    clearDashboardStats(state) {
      state.stats = initialState.stats;
    },
  },
});

export const {
  setDashboardStats,
  setTotalOrders,
  setPendingOrders,
  setSyncedOrders,
  setMonthlyOrdersData,
  setLoading,
  setError,
  clearError,
  clearDashboardStats,
} = dashboardStatsSlice.actions;

export default dashboardStatsSlice.reducer;
